import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchVisitSchedule = async ({ visitId, patientId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!patientId) params.append("patient_id", patientId);

  const URL = `${__API_URL__}/api/photos/get_visit_schedule/${visitId}/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetVisitSchedule = ({ visitId, patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_schedule", visitId, patientId],
    queryFn: () => fetchVisitSchedule({ visitId, patientId }),
    enabled: enabled && Boolean(visitId && visitId > 0),
  });
};

export default useGetVisitSchedule;
